import { render, staticRenderFns } from "./DevelopmentTypes.vue?vue&type=template&id=ec9e1418"
import script from "./DevelopmentTypes.vue?vue&type=script&lang=js"
export * from "./DevelopmentTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports